var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 19.2725L13.4453 17.7725",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.951172 15.2727V0H6.79776C7.90146 0 8.81871 0.174006 9.54954 0.522017C10.2853 0.865057 10.8347 1.33487 11.1976 1.93146C11.5655 2.52805 11.7495 3.20419 11.7495 3.95987C11.7495 4.58132 11.6301 5.11328 11.3915 5.55575C11.1529 5.99325 10.8322 6.34872 10.4295 6.62216C10.0268 6.8956 9.57688 7.09197 9.07972 7.21129V7.36044C9.62163 7.39027 10.1412 7.55682 10.6383 7.86009C11.1404 8.15838 11.5506 8.58097 11.8688 9.12784C12.187 9.67472 12.3461 10.3359 12.3461 11.1115C12.3461 11.902 12.1547 12.6129 11.7718 13.2443C11.389 13.8707 10.8123 14.3654 10.0417 14.7283C9.27113 15.0913 8.30167 15.2727 7.13335 15.2727H0.951172ZM3.71786 12.9609H6.69336C7.69762 12.9609 8.42099 12.7695 8.86346 12.3867C9.3109 11.9989 9.53462 11.5018 9.53462 10.8952C9.53462 10.4428 9.42276 10.0352 9.19904 9.67223C8.97532 9.30433 8.65714 9.01598 8.2445 8.80717C7.83185 8.5934 7.33967 8.48651 6.76793 8.48651H3.71786V12.9609ZM3.71786 6.49538H6.45472C6.932 6.49538 7.36204 6.40838 7.74485 6.23438C8.12766 6.0554 8.42844 5.80433 8.64719 5.48118C8.87092 5.15305 8.98278 4.76527 8.98278 4.31783C8.98278 3.72621 8.77397 3.23899 8.35636 2.85618C7.94372 2.47337 7.32972 2.28196 6.51438 2.28196H3.71786V6.49538Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.033e13a3d5c3b4166f6373758d1ffe0e.svg";
export { ForwardRef as ReactComponent };